import _regeneratorRuntime from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _toConsumableArray from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

export var GridViewApiEventEnum;

(function (GridViewApiEventEnum) {
  GridViewApiEventEnum["onSettingsCreate"] = "ON_SETTINGS_CREATE";
  GridViewApiEventEnum["onSettingsUpdate"] = "ON_SETTINGS_SAVE";
  GridViewApiEventEnum["onSettingsDelete"] = "ON_SETTINGS_DELETE";
  GridViewApiEventEnum["onSettingsSwitch"] = "ON_SETTINGS_SWITCH";
  GridViewApiEventEnum["onSettingsReset"] = "ON_SETTINGS_RESET";
})(GridViewApiEventEnum || (GridViewApiEventEnum = {}));

var GridViewApi = function GridViewApi(store) {
  var _this = this;

  _classCallCheck(this, GridViewApi);

  this.events = new Map();

  this.addEvent = function (event, callback) {
    _this.events = _this.events.set(event, callback);
  };

  this.triggerEvent = function (event, parameters) {
    var callback = _this.events.get(event);

    if (callback) {
      callback.apply(void 0, _toConsumableArray(parameters));
    }
  };
  /** triggers */


  this.triggerSettingsCreate = function (parentGridSettings) {
    _this.triggerEvent(GridViewApiEventEnum.onSettingsCreate, [parentGridSettings]);
  };

  this.triggerSettingsUpdate = function (parentGridSettings) {
    _this.triggerEvent(GridViewApiEventEnum.onSettingsUpdate, [parentGridSettings]);
  };

  this.triggerSettingsDelete = function (parentGridSettingsId) {
    _this.triggerEvent(GridViewApiEventEnum.onSettingsDelete, [parentGridSettingsId]);
  };

  this.triggerSettingsSwitch = function (parentGridSettingsId) {
    _this.triggerEvent(GridViewApiEventEnum.onSettingsSwitch, [parentGridSettingsId]);
  };

  this.triggerSettingsReset = function () {
    _this.triggerEvent(GridViewApiEventEnum.onSettingsReset, []);
  };
  /** consumers */


  this.consumeSettingsCreate = function (parentGridSettings) {
    return __awaiter(_this, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var gs, gridSettingsId;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              gs = this.store.createGridSettingsByParent(parentGridSettings);
              _context.next = 3;
              return this.store.gridSettingSave(gs);

            case 3:
              gridSettingsId = _context.sent;
              this.store.gridSettingSwitch(gridSettingsId);

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));
  };

  this.consumeSettingsUpdate = function (parentGridSettings) {
    return __awaiter(_this, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2() {
      var gridSettings, gs;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              gridSettings = this.store.findGridSettingsByParentId(parentGridSettings.id);

              if (!gridSettings) {
                _context2.next = 5;
                break;
              }

              gs = gridSettings.copyMulti({
                name: parentGridSettings.name,
                icon: parentGridSettings.icon
              });
              _context2.next = 5;
              return this.store.gridSettingSave(gs);

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));
  };

  this.consumeSettingsDelete = function (parentGridSettingsId) {
    return __awaiter(_this, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee3() {
      var gridSettings;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              gridSettings = this.store.findGridSettingsByParentId(parentGridSettingsId);

              if (!gridSettings) {
                _context3.next = 4;
                break;
              }

              _context3.next = 4;
              return this.store.gridSettingDelete(gridSettings.id);

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));
  };

  this.consumeSettingsSwitch = function (parentGridSettingsId) {
    var gridSettings = _this.store.findGridSettingsByParentId(parentGridSettingsId);

    if (gridSettings) {
      _this.store.gridSettingSwitch(gridSettings.id);
    }
  };

  this.comsumeSettingsReset = function () {
    _this.store.doGridSettingsReset();
  };

  this.store = store;
};

export { GridViewApi as default };